import React from 'react';
import PropTypes from 'prop-types';

const AppleRemove = props => (
  <div>
    <button
      type="button"
      id="btnSubmit"
      action="desvincular"
      className="btn btn-primary btn-block margin-05"
      onClick={props.removeApple}
    >
      Desvincular de Apple
    </button>
  </div>
);

AppleRemove.propTypes = {
  removeApple: PropTypes.func,
};

export default AppleRemove;
